import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { baseButtonStyles } from './LytBaseButton';
const StyledInvisibleButton = styled.button.withConfig({
    shouldForwardProp: (prop) => !['isCompact', 'isIconOnly'].includes(prop),
})`
    ${baseButtonStyles}
    background-color: ${({ theme }) =>
        theme.components.lyt_button.invisible.background.default};
    color: ${({ theme }) => theme.components.lyt_button.invisible.text.default};

    &:not(:disabled):hover {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.invisible.background.hover};
        color: ${({ theme }) =>
            theme.components.lyt_button.invisible.text.hover};
    }

    &:not(:disabled):active {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.invisible.background.pressed};
        color: ${({ theme }) =>
            theme.components.lyt_button.invisible.text.pressed};
    }

    &:focus-visible {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.invisible.background.focus};
        outline: 2px solid
            ${({ theme }) => theme.components.lyt_button.invisible.border.focus};
        outline-offset: 1px;
    }

    &:disabled {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.invisible.background.disabled};
        color: ${({ theme }) =>
            theme.components.lyt_button.invisible.text.disabled}4D;
    }

    &.lyt-button-selected {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.invisible.background.selected};
        color: ${({ theme }) =>
            theme.components.lyt_button.invisible.text.selected};

        &:hover {
            background-color: ${({ theme }) =>
                theme.components.lyt_button.invisible.background.selected};
            color: ${({ theme }) =>
                theme.components.lyt_button.invisible.text.selected};
        }
    }
`;
const LytInvisibleButton = ({ isCompact = false, ...props }) => {
    return <StyledInvisibleButton isCompact={isCompact} {...props} />;
};
LytInvisibleButton.propTypes = {
    isCompact: PropTypes.bool,
};
export default LytInvisibleButton;
